import * as React from 'react';

type CarouselImageProps = {
  src: string;
  style?: React.CSSProperties;
  className?: string;
};

const carouselImageDefaultStyle: React.CSSProperties = {
  height: '100%',
  width: '100%',
  objectFit: 'cover',
};

const CarouselImage: React.FunctionComponent<CarouselImageProps> = ({
  src,
  className = 'zoom',
  style = carouselImageDefaultStyle,
}) => (
    <div
      className="listing-view-asset"
      style={{ height: '100%', width: '100%' }}
    >
      <img src={src} className={className} style={style} />
    </div>
  );

export default CarouselImage;
